import {createAction, props} from '@ngrx/store';
import {Organisation} from "../model/Organisation";

const FEATURE_KEY = 'Organisation'
const ENTITY_MODEL: Organisation = null;

export const createOrganisationSuccess = createAction(
  '[Organisation] Create record success',
  props<{ organisation : typeof ENTITY_MODEL}>()
)
